module.exports = __webpack_public_path__ + "static/hellersign-6dab8a54b078b62602e7ec3ac15bf32f.png";